import { IIncomeType, queryKeys } from '../../shared';
import { useDelete, useSave } from '../../shared/hooks/new-base.hook';
import { useItem, UseItemParams, useList, UseListParams } from '../../shared/hooks/new-read-only.hook';
import { incomeTypeClient } from '../clients/income-type.client';

const client = incomeTypeClient;
const listKey = queryKeys.INCOME_TYPES;
const itemKey = queryKeys.INCOME_TYPE;

export function useIncomeTypesList(...args: UseListParams<IIncomeType>) {
    return useList(client, listKey, args);
}

export function useIncomeType(...args: UseItemParams<IIncomeType>) {
    return useItem(client, itemKey, args);
}

export function useSaveIncomeType() {
    return useSave(client, listKey, itemKey);
}

export function useDeleteIncomeType() {
    return useDelete(client, listKey);
}
